import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TemplateDeployment } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import DeploymentStateBadge from "../../StateBadge";

const TemplateDeploymentsStatusCell = ({
  item: deployment,
  ...cellProps
}: TableSimpleCellProps<TemplateDeployment>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <DeploymentStateBadge state={deployment.state} />
    </TableSimpleCell>
  );
};

export default TemplateDeploymentsStatusCell;
